// src/pages/Verify.tsx
import { useEffect, useState, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../api/axios';

export default function Verify() {
  const nav = useNavigate();
  const { search } = useLocation();
  const { t } = useTranslation();

  const [msg, setMsg] = useState(t('verify.verifying') || 'Verifying...');
  const [sub, setSub] = useState<string | null>(null); // 追加メッセージ（失敗理由など）
  const [done, setDone] = useState(false);

  // /verify?token=...&redirectTo=... を想定（未指定時は /login）
  const params = useMemo(() => new URLSearchParams(search), [search]);
  const token = params.get('token') || '';
  const redirectTo = params.get('redirectTo') || '/login';

  useEffect(() => {
    if (!token) {
      setMsg(t('verify.failed') || 'Verification failed');
      setSub(t('verify.token_missing') || 'Verification token is missing');
      setDone(true);
      return;
    }

    (async () => {
      try {
        const { data } = await api.get('/auth/verify', { params: { token } });

        // バックエンドが coupon / lc を返す場合、ログイン後の自動適用用に保存
        if (data?.coupon) sessionStorage.setItem('pending_coupon_code', String(data.coupon));
        if (data?.lc) sessionStorage.setItem('pending_coupon_link_code', String(data.lc));

        setMsg(t('verify.success') || 'Email verified. Please log in.');
        setSub(null);
        setDone(true);

        // 少し待ってから遷移
        setTimeout(() => {
          nav(redirectTo);
        }, 1000);
      } catch (e: any) {
        const detail =
          e?.response?.data?.detail ||
          e?.message ||
          t('verify.token_expired') ||
          'Verify failed or token expired';
        setMsg(t('verify.failed') || 'Verification failed');
        setSub(typeof detail === 'string' ? detail : t('verify.token_expired') || '');
        setDone(true);
      }
    })();
  }, [token, nav, redirectTo, t]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="p-6 bg-white rounded-xl shadow w-full max-w-md text-center">
        <h1 className="text-xl font-semibold mb-2">{msg}</h1>
        {sub && <p className="text-gray-600">{sub}</p>}
        {!done && (
          <div className="mt-4 text-sm text-gray-500">
            {t('verify.checking') || 'Checking your token...'}
          </div>
        )}
        {done && (
          <button
            onClick={() => nav(redirectTo)}
            className="mt-6 px-4 py-2 rounded-lg bg-coral text-white hover:opacity-90"
          >
            {t('verify.continue') || 'Continue'}
          </button>
        )}
      </div>
    </div>
  );
}
